import { Person, Remove } from "@mui/icons-material";
import {
  Avatar,
  Badge,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { capitalizeWords } from "src/shared/global/helpers";
import { userState } from "src/store/user/userState";
import { checkIsOwner } from "../utils/ownerUtils";
import { showModalFamilyGroupState } from "../atom";
import useAuthPatient from "src/Patient/hooks/useAuthPatient";
import { AlertModal } from "./AlertModal";
import { useState } from "react";

export const FamilyList = ({
  headerContent = null,
  isEditable = true,
  familyGroup = [],
  payloadToken = {},
  removeFamilyMember = () => {},
}) => {
  const user = useRecoilValue(userState);
  const activeAccount = checkIsOwner(user);
  const setShowModalFamilyGroup = useSetRecoilState(showModalFamilyGroupState);
  const { getDetailPatient } = useAuthPatient();

  const handleListItemClick = async (value) => {
    window.sessionStorage.setItem("activeAccount", value);
    await getDetailPatient();
    setShowModalFamilyGroup(false);
    window.location.reload();
  };

  const [showAlert, setShowAlert] = useState(false);
  const [pacRut, setPacRut] = useState("");
  const [pacCorrel, setPacCorrel] = useState("");

  return (
    <div>
      <AlertModal
        open={showAlert}
        onClose={() => setShowAlert(false)}
        onConfirm={() => {
          removeFamilyMember({
            tutRut: payloadToken?.Username,
            rutPaciente: pacRut,
            pacCorrel: pacCorrel,
            actorRol: "tutor",
          });
          setShowAlert(false);
        }}
        title="Confirmar eliminación"
        message="¿Estás seguro de que deseas eliminar este miembro del grupo?"
      />
      {!headerContent && (
        <Stack>
          <Typography variant="subtitle2" fontWeight={600}>
            Mi grupo familiar
          </Typography>
          <Typography variant="caption" color="textSecondary">
            Aquí puedes gestionar a los miembros de tu grupo familiar. Puedes
            agregar y eliminar miembros.
          </Typography>
        </Stack>
      )}
      {headerContent && headerContent}
      <List>
        <ListItem key={payloadToken?.Username} sx={{ padding: 0 }}>
          <ListItemButton
            onClick={() => handleListItemClick(payloadToken?.Username)}
          >
            <ListItemAvatar>
              <Avatar>
                <Person />
              </Avatar>
            </ListItemAvatar>
            <Stack p={0} spacing={0} sx={{ width: "100%" }}>
              <Stack>
                <ListItemText
                  primaryTypographyProps={{ fontWeight: 600 }}
                  primary={`Yo`}
                />
                <ListItemText
                  secondaryTypographyProps={{
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                  secondary={`Dueño de la cuenta`}
                />
              </Stack>
            </Stack>
          </ListItemButton>
        </ListItem>
        {familyGroup.map(({ paciente, usuario, tutCuentaVerificada }) => (
          <ListItem
            key={paciente?.pacRut || usuario?.uswRut}
            sx={{ padding: 0 }}
            secondaryAction={
              isEditable && (
                <IconButton
                  edge="end"
                  aria-label="remove"
                  onClick={() => {
                    setShowAlert(true);
                    setPacRut(usuario?.uswRut);
                    setPacCorrel(paciente?.pacCorrel.toString());
                  }}
                  disabled={!activeAccount.isOwner}
                > 
                  <Remove />
                </IconButton>
              )
            }
          >
            <ListItemButton
              onClick={() => {
                if (!tutCuentaVerificada) {
                  return;
                }
                handleListItemClick(paciente?.pacRut || usuario?.uswRut);
              }}
              disabled={!tutCuentaVerificada}
            >
              <ListItemAvatar>
                <Badge
                  overlap="circular"
                  variant="dot"
                  color="primary"
                  invisible={paciente?.pacRut !== user?.payload?.uswRut}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                >
                  <Avatar>
                    <Person />
                  </Avatar>
                </Badge>
              </ListItemAvatar>
              <Stack p={0} spacing={0} sx={{ width: "100%" }}>
                <Stack>
                  <ListItemText
                    primaryTypographyProps={{ fontWeight: 600 }}
                    primary={capitalizeWords(
                      `${paciente?.pacNombres || usuario?.uswNombres} ${
                        paciente?.pacPaterno || usuario?.uswApePat
                      } ${paciente?.pacMaterno || usuario?.uswApeMat}`
                    )}
                    secondaryTypographyProps={{
                      fontSize: 14,
                      fontWeight: 500,
                    }}
                    secondary={`${
                      tutCuentaVerificada ? "" : "Pendiente de confirmación"
                    }`}
                  />
                </Stack>
              </Stack>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );
};
